import { CommonModule, NgIf, NgFor, isPlatformBrowser } from '@angular/common';

import { Component, EventEmitter, OnInit, Output, ViewEncapsulation, Inject, PLATFORM_ID, ViewChild, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterLink } from '@angular/router';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { FooterComponent } from '../footer/footer.component';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { PartnersComponent } from '../partners/partners.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { GoogleMapsModule } from '@angular/google-maps';
import { IAlert } from 'app/core/shared-services/interfaces.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';

import { NetworkPanelComponent } from '../../network_panel/network_panel.component';
import moment from 'moment';
import { MatDialogModule } from '@angular/material/dialog';
import { InnerHTMLPipe } from 'app/core/pipes/innerHTML.pipe';
import { SwiperPackagesComponent } from 'app/modules/dashboard/package-options/swiper-packages/swiper-packages.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { GoogleSearchBarComponent } from 'app/modules/google-search-bar/google-search-bar.component';
 
 

declare var $: any;

@Component({
    selector     : 'landing-home',
    templateUrl  : './home.component.html',
    styleUrls  : ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [NgFor, RouterLink, SharedMethodsModule, MatButtonModule, MatDialogModule, InnerHTMLPipe,
       NgIf, GoogleMapsModule, FooterComponent, RouterLink, MatIconModule,
        MatInputModule, MatAutocompleteModule, FormsModule, CommonModule, FuseAlertComponent, 
        PartnersComponent,NetworkPanelComponent, GoogleSearchBarComponent, SlickCarouselModule, SwiperPackagesComponent, NgxSkeletonLoaderModule ],
})


export class LandingHomeComponent implements OnInit
{

    @Output() alertNotification = new EventEmitter<IAlert>();
    @ViewChild('searchTextRef') searchInputRef: ElementRef;


    public showAlert: boolean = false;
    public alert: { type: FuseAlertType; message: string };
    private customer: any
    public packagesFound: boolean = true;
    public spinner: boolean = false;
    public headerImage: string;
    public headerTitle: string;
    public headerBody: string;
    public featuredImage:string;
    public testimonials: any;
    public blogs:any;
    public headerTextColor: string;
    public bannerTitle: string;
    public bannerBody: string;
    public learnMoreTitle: string;
    public learnMoreBody: string;
    public bodyTextColor:string;
    public homePageReasons: any;
    public homePageBanners: any[] = [];

    private isScreenSmall: boolean;
    private _unsubscribeAll: Subject<any> = new Subject<any>();


    private referrer: string;


    /**
     * Constructor
     */
    constructor(
      private _sharedMethods: SharedMethodsModule,
      private router: Router,
      private _strapiService: StrapiService,
      private _fuseMediaWatcherService: FuseMediaWatcherService,
      private _gtmService: GtmService,


      @Inject(PLATFORM_ID) private platformId: any
    )
    {}

  // -----------------------------------------------------------------------------------------------------
  // @ On Init
  //


    async ngOnInit()
    {

      
    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }


        const route = window.location.href;
        const path = this.router.url;

        this._gtmService.pushEvent({ 
          event: 'page_view',
          page_url: route,
          page_path: path,
          page_title: 'home_page',
          page_referrer: this.referrer ? this.referrer : ''
        });

      // Subscribe to media changes
      this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({matchingAliases}) =>
      {
          // Check if the screen is small
     
          this.isScreenSmall = !matchingAliases.includes('md');
      });
      

      if(localStorage.getItem('accessToken')) {
        this.customer = await this._sharedMethods.getCustomerAccount();
      }

      //Used to add styling for background images on the home page
      const style = document.createElement('style');

      // get content from Strapi
      this._strapiService.getHomeHeaderContent()
      .subscribe({
          next: (res: any) => 
          {        
            if(this.isScreenSmall) {
              this.headerImage = res.data.mobileImage.url;

            } else {
              this.headerImage = res?.data?.image.url;
            }
              this.headerTitle = res?.data?.headerText;
              this.headerBody = res?.data?.bodyText;
              this.headerTextColor = res?.data?.text_color_hex;

              // Append the style element to the head of the document
              document.head.appendChild(style);
          }
      });
    }
      
      

      this._strapiService.getHomeBodyContent()
      .subscribe({
          next: (res: any) => {
            this.testimonials = res?.data?.testimonials;
            this.featuredImage = res?.data?.image?.url;
            this.bannerTitle = res?.data?.banner_header;
            this.bannerBody = res?.data?.banner_header;
            this.learnMoreTitle = res?.data?.learn_more_title;
            this.learnMoreBody = res?.data?.learn_more_text;
            this.bodyTextColor = res?.data?.text_color_hex;
            setTimeout(function()
            { 
              $('.slick-carousel').slick({
                autoplay: true,
                autoplaySpeed: 5000,
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1
              });
            },1000)
          }
      });

      this._strapiService.getHomePageReasons()
      .subscribe({
        next: (res: any)=>{
          this.homePageReasons = res.data;
        }
      })

      this._strapiService.getHomePageBanners()
      .subscribe({
        next: (res: any)=>{
          res.data.forEach(element => {
            this.homePageBanners.push(element);
          });
      
        }
      })



       
      //this.getBlogs();
 
    }

  /**
     * On destroy
     */
  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
      this.spinner = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  getBlogs()
  {
      this._strapiService.getBlogs().subscribe({
          next: (res: any) => 
          {
              this.blogs = res.data.map(function(blog)
              {
                  return {
                      ...blog,
                      dateFormatted: moment(blog.createdAt).format("DD MMMM YYYY")
                  };
              })
          },
      });
  }
    
  viewBlog(blogId: string) 
  {
      this.router.navigate(['/blogs', blogId]);
  }

    // testimonials = [
    //   { text: "I have only had the best service and experience from Supersonic. They have assisted me in a professional and highly skilled manner every time.", author: "Andres Cameron", rating: 5 },
    //   // Add more testimonials as needed
    // ];

  currentIndex = 0;

  focusOnSearch(): void 
  {
      if (this.searchInputRef) {
          this.searchInputRef?.nativeElement.focus();
      }
  }

}


